import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["accept"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "file-input",
    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.handleClick()), ["stop"]))
  }, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    _createElementVNode("input", {
      class: "input",
      type: "file",
      name: "upload",
      ref: "inputRef",
      accept: _ctx.accept,
      onChange: _cache[0] || (_cache[0] = $event => _ctx.handleChange($event))
    }, null, 40, _hoisted_1)
  ]))
}